import { AppData, Log } from "@lightningjs/sdk";
import { AppSetup } from "./app-setup";
import { Helper } from "./helper";

export class CCConfig {
    userConfig: [CCSettingsOptionsType] = defaultCCSettings()
    showSubtitle = false
    fontsLoaded = false
    appSetup!:AppSetup

    init(appSetup) {
        this.appSetup = appSetup
        this.loadSavedSettings(appSetup);
        this.loadFonts()
    }

    loadSavedSettings = (appSetup:AppSetup) => {
        const { appConfig } = appSetup
        let ccValues = ''
        if (appConfig.useLocalStorage == true) {
            ccValues = localStorage.getItem('cc-settings-v2') || '';
        } else {
            ccValues = Helper.getCookie('cc-settings-v2');
        }
        //fix for rollback to legacy version. where the setting format is changed.
        //localStorage.removeItem('cc-settings');
        if (appConfig.useLocalStorage == true) {
            localStorage.removeItem('cc-settings');
        } else {
            Helper.setGeneralCookie('cc-settings-v2', '', 0);
        }
        Log.info('loadSavedSettings ccValues: ' + ccValues);
        if (ccValues!== '') {
            let ccValArr = ccValues.split('|')
            for (let i = 0; i < ccValArr.length; i++) {
                let val: any = ccValArr[i];
                if (i == 0) {
                    if (ccValArr[i] == "true") {
                        val = true;
                    } else {
                        val = false;
                    }
                }
                if (i == 2 || i == 7) {
                    val = parseFloat(ccValArr[i])
                }
                this.userConfig[i].value = val;
            }
        } else {
            this.saveSettings();
        }
        // console.log('loadSavedSettings userConfig: ', this.userConfig);
    }

    loadFonts() {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://fonts.googleapis.com/css2?family=Courgette&family=Courier+Prime&family=Gothic+A1&family=Itim&family=Lora&family=Roboto&family=Ubuntu+Mono&display=swap';
        document.getElementsByTagName('head')[0].appendChild(link);
    }

    saveSettings() {
        const { appConfig } = this.appSetup;
        const val = this.userConfig.map((value, index) => {
            return value.value;
        });
        if (appConfig.useLocalStorage == true) {
            localStorage.setItem('cc-settings-v2', val.join('|'));
        } else {
            Helper.setGeneralCookie('cc-settings-v2', val.join('|'), 365);
        }
        //localStorage.setItem('cc-settings-v2', val.join('|'));
        Log.info('saveSettings ccValues:', val);
    }

    resetDefault() {
        this.userConfig = defaultCCSettings()
        this.saveSettings()
        this.updateCSS()
    }

    updateCSS() {
        const { appState } = AppData as AppSetup
        appState.showSubtitle = this.userConfig[0].value
        const fontColor = this.userConfig[1].value
        const fontOpacity = this.userConfig[2].value
        const fontSize = this.userConfig[3].value
        const fontFace = this.userConfig[4].value
        const edge = this.userConfig[5].value
        const bgColor = this.userConfig[6].value
        const bgOpacity = this.userConfig[7].value
        const resolution = (window.innerWidth/1920).toPrecision(7)

        const styleStr = `
                    background: rgba(${bgColor},${bgOpacity});
                    color: rgba(${fontColor},${fontOpacity});
                    font: ${Math.round(fontSize * resolution)}px ${fontFace};
                    text-shadow: ${edge};
                    padding: 10px 20px;
                `
        //console.log(styleStr)
        if (document.querySelector('#subtitle-cc-sample span')) {
            document.querySelector('#subtitle-cc-sample span').setAttribute('style', styleStr);
        }
        if (document.querySelector('#subtitle span')) {
            document.querySelector('#subtitle span').setAttribute('style', styleStr);
        }
        Log.info('cc style:', `
            bg-color: rgba(${bgColor},${bgOpacity});
            color: rgba(${fontColor},${fontOpacity});
            font-family: ${fontFace};
            font-size: ${fontSize};
            text-shadow: ${edge};
            padding: 10px 20px;
        `)
    }
}

export type CCSettingsOptionsType = {
    name: string,
    options: [CCSettingsOptionsValueType],
    value: boolean | number | string
}

export type CCSettingsOptionsValueType = {
    name: string,
    value: boolean | number | string
    isActive: boolean
}

export const defaultCCSettings = (): [CCSettingsOptionsType] => {
    return [
        {
            'name': 'Captions', 'options': [
                { 'name': 'On', value: true, isActive: false },
                { 'name': 'Off', value: false, isActive: true }
            ], value: false
        },
        {
            'name': 'Character Color', 'options': [
                { 'name': 'White', value: '255, 255, 255', isActive: true },
                { 'name': 'Black', value: '0, 0, 0', isActive: false },
                { 'name': 'Red', value: '255, 0, 0', isActive: false },
                { 'name': 'Green', value: '0, 255, 0', isActive: false },
                { 'name': 'Blue', value: '0, 0, 255', isActive: false },
                { 'name': 'Yellow', value: '255, 255, 0', isActive: false },
            ], value: '255, 255, 255'
        },
        {
            'name': 'Character Opacity', 'options': [
                { 'name': '75% Transparent', value: .25, isActive: false },
                { 'name': '50% Transparent', value: .5, isActive: false },
                { 'name': '25% Transparent', value: .75, isActive: false },
                { 'name': 'Solid', value: 1, isActive: true },
            ], value: 1
        },
        {
            'name': 'Character Size', 'options': [
                { 'name': 'Small', value: 24, isActive: false },
                { 'name': 'Medium', value: 28, isActive: false },
                { 'name': 'Standard', value: 36, isActive: true },
                { 'name': 'Large', value: 42, isActive: false },
                { 'name': 'Extra-Large', value: 48, isActive: false },
            ], value: 36
        },
        {
            'name': 'Font', 'options': [
                { 'name': 'Default', value: 'Times', isActive: true },
                { 'name': 'Courier', value: 'Courier Prime', isActive: false },
                { 'name': 'Lora', value: 'Lora', isActive: false },
                { 'name': 'Mono', value: 'Ubuntu Mono', isActive: false },
                { 'name': 'Roboto', value: 'Roboto', isActive: false },
                { 'name': 'Casual', value: 'Itim', isActive: false },
                { 'name': 'Courgette', value: 'Courgette', isActive: false },
                { 'name': 'Small Caps', value: 'Gothic A1', isActive: false }
            ], value: 'Times'
        },
        {
            'name': 'Caption Edge Attribute', 'options': [
                { 'name': 'No Edge', value: 'none', isActive: true },
                { 'name': 'Raised', value: '0px 2px 0px #666, 0px 4px 0px #666', isActive: false },
                { 'name': 'Depressed', value: '0px -2px 0px #999, 0px 2px 0px #999', isActive: false },
                { 'name': 'Uniform', value: '-2px 0px 0px #999, 2px 0px 0px #999', isActive: false },
                { 'name': 'Drop Shadow', value: '0px 0px 5px #333, 0px 0px 5px #333, 0px 0px 5px #333, 0px 0px 5px #333', isActive: false }
            ], value: 'none'
        },
        {
            'name': 'Caption Window Color', 'options': [
                { 'name': 'White', value: '255, 255, 255', isActive: true },
                { 'name': 'Black', value: '0, 0, 0', isActive: false },
                { 'name': 'Red', value: '255, 0, 0', isActive: false },
                { 'name': 'Green', value: '0, 255, 0', isActive: false },
                { 'name': 'Blue', value: '0, 0, 255', isActive: false },
                { 'name': 'Yellow', value: '255, 255, 0', isActive: false },
            ], value: '0, 0, 0'
        },
        {
            'name': 'Caption Window Opacity', 'options': [
                { 'name': '100% Transparent', value: 0, isActive: false },
                { 'name': '75% Transparent', value: .25, isActive: false },
                { 'name': '50% Transparent', value: .5, isActive: false },
                { 'name': '25% Transparent', value: .75, isActive: false },
                { 'name': 'Solid', value: 1, isActive: true },
            ], value: 1
        },
        {
            'name': 'Reset Default Caption Settings', 'options': null, value: null
        }
    ]
}
